<script lang="ts">
    export let address: OperationAddress
</script>

{address.name1}{(address.name2 && ", " + address.name2) || ""}{(address.name3 && ", " + address.name3) || ""}, {(address.street &&
    address.street + ", ") ||
    ""}{address.postcode || ""}, {address.city || ""}
